import './PageNotFound.css';
import WaterDropGrid from '../components/DotGrid';

function PageNotFound() {
  return (
    <div className="Layer0">
        <WaterDropGrid/>
        
    </div>
  );
}

export default PageNotFound;
